<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper restore__pass-main">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form
      :class="{loading: loading, error: error}"
      @submit.prevent
    >
      <Card class="card-login pt-20">
        <section class="inputs">
          <h3 class="mb-6">
            {{ $t('forms.restorePassword') }}
          </h3>
          <div class="row mb-18">
            <div class="col-md-9 col-12">
              {{ $t('forms.restoreText') }}
            </div>
          </div>
          <UiInput
            v-model="model.email"
            v-model:error="errors_.email"
            :label="$t('forms.emailLabel')"
            :placeholder="$t('forms.emailPlaceholder')"
            class="mb-16"
            autofocus
            wrapper-type="registration"
            error-clear-on-change
            @input="checkValid"
          />
          <div
            v-show="isCaptchaV2Required"
            class="ui-m-lg-b"
          >
            <VueRecaptcha
              ref="captchaV2"
              :sitekey="$store.state.misc.miscSettings.recaptcha.public_key_v2"
              @verify="verifyV2"
            />
          </div>
          <div class="btn-box !tw-flex !tw-justify-between">
            <RouterLink
              :to="{ path: '/login'}"
              class="btn btn-outline-primary btn-md"
              replace
            >
              &lt; {{ $t('forms.btn.back') }}
            </RouterLink>
            <button
              :disabled="!valid_email || loading || (isCaptchaV2Required && !recaptchaTokenV2)"
              class="btn btn-primary btn-md"
              @click="requestRestore"
            >
              {{ $t('forms.btn.submit') }} >
            </button>
          </div>
        </section>
      </Card>
      <div class="loading__block">
        <i class="fa fa-spinner fa-3x fa-fw login__spinner" />
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';


export default {
  data() {
    return {
      emailValidation: false,
      passwordValidation: false,
      isCaptchaV2Required: false,
      recaptchaTokenV2: null,
      recaptchaTokenV3: null,
      loading: false,
      valid_email: false,
      errors_: {},
      model: {
        email: '',
      },
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      model: {
        email: { required, email },
      },
    };
  },
  computed: {

    error() {
      return this.$store.state.errors.request >= 400;
    },
    logo() {
      return this.$config.layout.logoFull;
    },
  },
  methods: {
    verifyV2(token) {
      this.recaptchaTokenV2 = `google_recaptcha_v2__${token}`;
    },
    async recaptcha() {
      try {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('forgot_password');
        this.recaptchaTokenV3 = `google_recaptcha_v3__${token}`;
      } catch (error) {
        console.log(error);
      }
    },
    async checkValid() {
      this.valid_email = await this.v$.$validate();
    },
    async requestRestore() {
      this.loading = true;
      const recaptcha_token = this.recaptchaTokenV2 || this.recaptchaTokenV3;

      try {
        await this.$request.post('auth/forgot-password', {
          email: this.model.email,
          return_url: `${window.location.origin}/#/reset-password/%%TOKEN%%/%%AFFILIATE_EMAIL%%`,
          ...(recaptcha_token && { recaptcha_token }),
        });
        this.$router.push('/restore-success');
      } catch (err) {
        this.errors_ = err.response?.data?.errors || {};

        if (this.errors_.hasOwnProperty('recaptcha_token')) {
          if (!this.recaptchaTokenV3) {
            await this.recaptcha();
            return await this.requestRestore();
          }

          if (!this.recaptchaTokenV2) {
            this.isCaptchaV2Required = true;
            this.loading = false;
            return;
          }

          this.$alert.error(this.$t('alerts.captchaRequestFailed'));
        }

        this.loading = false;
      } finally {
        this.$refs.captchaV2?.reset();
        this.recaptchaTokenV2 = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import 'styles/restorepassword';
</style>
